import React from "react";
import ServiceSpace from "../../../components/dashboard/ServiceSpace";
import ErpAccessCard from "../../../components/dashboard/ErpAccessCard";
import pricing from "../../../assets/data/pricing.json";

function UserPlatformGest() {
  return (
    <ServiceSpace
      serviceCode="management"
      flow="management"
      flowPath="/platform-gest"
      title="Facturation"
      lead="Le module de facturation de votre Gestion 360."
      offer="Devis, factures, règlements et suivi de trésorerie dans un ERP en ligne."
      price={Math.min(
        pricing.platformGest.mensuel,
        pricing.platformGest.annuel,
      )}
      topContent={<ErpAccessCard />}
    />
  );
}

export default UserPlatformGest;
